/**
 * Contains axis api calls.
 * @module api/axis
 */
import Settings from '../settings';

const serverPath = Settings.serverPath;

/**
 * The base axis api call.
 * @param  {string}  query The url params to pass to the axis rest api
 */
const baseAxisApiCall = (query) => fetch(`${serverPath}Services/AxisApiRestService.svc/${query}`, {
  method: 'get',
  mode: 'cors',
  cache: 'no-cache',
  credentials: 'include',
  dataType: 'json'
});

/**
 * Handles the response returned by the axis api call.
 * @param  {Promise}  response The response returned by the axis api call
 */
const handleAxisApiResponse = (response) => new Promise((resolve) => {
  if (response.ok) {
    return resolve(response.text());
  }
  throw (new Error('Response not ok.'));
}).then(data => {
  if (data.statusCode === 500) {
    console.log(data);
    throw (new Error('Unexpected error getting data from axis.  Bad JSON received.'));
  }
  return Promise.resolve(JSON.parse(data));
});

/**
 * Gets the delivery feed from axis.
 * @func getDeliveryFeed
 */
export const getDeliveryFeed = () => baseAxisApiCall('GetDeliveryFeed')
  .then(handleAxisApiResponse)
  .catch(error => Promise.reject(`getDeliveryFeed failed: ${error}`));

/**
 * Gets the order status from axis.
 * @func getOrderStatus
 */
export const getOrderStatus = () => baseAxisApiCall('GetOrderStatus')
  .then(handleAxisApiResponse)
  .catch(error => Promise.reject(`getOrderStatus failed: ${error}`));

/**
 * Gets the maps status from axis.
 * @func getDeliveryFeed
 */
export const getMapStatus = () => baseAxisApiCall('GetMapsStatus')
  .then(handleAxisApiResponse)
  .catch(error => Promise.reject(`getMapsStatus failed: ${error}`));

export const getUserProfile = () => baseAxisApiCall('GetUserProfile')
  .then(handleAxisApiResponse)
  .catch(error => Promise.reject(`getUserProfile failed: ${error}`));

/**
 * Gets the Axis url to display in the compose window
 * @func createAxisDeficientAsset
 */
export const createAxisDeficientAsset = (user, contextId, axisService, assetType, assetTitle) =>
  baseAxisApiCall(`CreateAxisDeficientAsset/${contextId}/${axisService}/${assetType}/${assetTitle}/${user}`)
    .then(handleAxisApiResponse)
    .catch(error => Promise.reject(`createAxisDeficientAsset failed: ${error}`));


/**
 * Gets the order information for the current user
 * @func getOrderInitialization
 */
export const getOrderInitialization = () =>
  baseAxisApiCall('GetOrderInitialization')
    .then(handleAxisApiResponse)
    .catch(error => Promise.reject(`getOrderInitialization failed: ${error}`));


/**
 * Posts the order for submission
 * @func postSubmitOrder
 */
export const postSubmitOrder = (order) => fetch(`${serverPath}Services/AxisApiRestService.svc/SubmitOrder`, {
  method: 'post',
  mode: 'cors',
  body: JSON.stringify(order),
  cache: 'no-cache',
  credentials: 'include',
  dataType: 'json'
}).then(handleAxisApiResponse);

/** Posts attached files for created order
 * @func postAttachedFiles
 */
export const postAttachedFiles = (orderGuid, files) => {
  const formData = new FormData();

  formData.append('orderguid', orderGuid);
  files.forEach(file => {
    formData.append(file.name, file);
  });

  fetch(`${serverPath}UploadOrderAttachedFiles.ashx`, {
    method: 'post',
    mode: 'cors',
    body: formData,
    cache: 'no-cache',
    credentials: 'include',
    dataType: 'json'
  })
    .catch(error => {
      throw new Error(`postAttachedFiles failed: ${error}`);
    });
};



// WEBPACK FOOTER //
// ./app/api/axis.js